module.exports = __webpack_public_path__ + "static/media/logo16.3dab62ec.png";